import EqualHeightElementCollection from "@/ts/base/Components/EqualHeightElementCollection";

class EqualHeightCardCollection extends EqualHeightElementCollection {
	getSelector() {
		return ".card.equal-height";
	}

	getComponents(): NodeListOf<HTMLElement>[] {
		const selector = this.getSelector();
		return [
			(this.container || document).querySelectorAll(selector + " .card-illustration"),
			(this.container || document).querySelectorAll(selector + " .card-title"),
			(this.container || document).querySelectorAll(selector + " .card-text")
		];
	}
}

export default EqualHeightCardCollection;
